import END_POINT from 'src/config/endpoints.constants';
import { ApiResponse, ApiResult, getErrorMessage } from '../lib/API';
import { FirebaseToken, UUID, RegisterDeviceOptions } from '../types';
import axios from 'axios';
export interface RegisterDeviceResult extends ApiResult {
    data?: {
        message: string;
    };
}

export interface RegisterDeviceResponse extends ApiResponse {
    data: {
        deviceid: string;
        type: string;
        description: string;
        appname: string;
        appversion: string;
        devicetoken: FirebaseToken;
        devicemake: string;
        deviceos: string;
        usertype: string | null;
        mobilenumber: string | null;
        email: string | null;
        userId: UUID;
    };
}

export default async function registerDevice(
    options: RegisterDeviceOptions,
): Promise<RegisterDeviceResult> {
    const result: RegisterDeviceResult = {};
    try {
        const { data: responseData } = await axios.post<RegisterDeviceResponse>(
            END_POINT.USER_DEVICE_REGISTER,
            options,
        );
        if (responseData) {
            result.data = {
                message: responseData.message,
            };
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
